import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ModalFailed from "@Components/NewUI/Common/ModalFailed";
import { notifyVisitorEvent } from "@Redux/ApplyLoan/action";
import { referandearndiraction } from "@Redux/Manual_Kyc_Details/action";
import { fetchDashboardData } from "@Redux/Dashboard/action";
import bellnotify from "../../../assets/bellnifify.png";
import bell from "../../../Images/NewUI/blackbell.png";
import RepaySuperAppDashboard from "../User/RepaySuperAppDashboard";
import Header from "../Common/Headerr";
import { Loader } from "../Common/Loader";
import animationcoin from "../../../Images/NewUI/coine.png";
import SuperInstant from "../Common/SuperInstant";
import ToggleBar from "../DashBoardNew/ToggleBar";
import LoanRejectZet from "../User/NewUser/SuperAppComponents/LoanRejectZet";

function LoanSuperAppDashboard() {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const {
    loading,
    loanStatus,
    documentStatus: basicDetails,
    creditModel: credit_model,
    blocked,
    cibilFlow,
    hasReadNotification: isNotify,
  } = useSelector((state) => state.dashboard);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  const token = user?.User?.token || localStorage.getItem("gpay_token");
  const loanType = credit_model?.loan_type || "";
  const emi = loanType !== "P";

  useEffect(() => {
    localStorage.removeItem("loanAmount");
    localStorage.removeItem("loanReason");

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);

    dispatch(fetchDashboardData(token));

    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch, token]);

  const handleNotificationredirection = (e) => {
    e.stopPropagation();
    setTimeout(() => {
      window.location.href = "/notifications";
    }, 200);
  };

  return (
    <div>
      {loading && <Loader />}
      <div className="container">
        {loanStatus?.loan_status === "DISBURSED" ||
        loanStatus?.loan_status === "BALANCE_AMOUNT" ? (
          <RepaySuperAppDashboard
            event={"loan"}
            canApply={basicDetails?.can_apply_for_loan}
            userType={basicDetails?.user_type}
          />
        ) : (
          <>
            <div className="flex_row justifycontentSpacebetn mt-16 ">
              <Header documentStatus={basicDetails} />
              <span className="notify belldesign">
                <div className="flex items-center">
                  <div onClick={handleNotificationredirection}>
                    {isNotify ? (
                      <img
                        src={bell}
                        alt="img"
                        width={"27px"}
                        height={"27px"}
                      />
                    ) : (
                      <img
                        src={bellnotify}
                        alt="img"
                        width={"27px"}
                        height={"30px"}
                        style={{ marginTop: "5px" }}
                      />
                    )}
                  </div>
                </div>
              </span>
            </div>
            {!blocked && (
            <div className="containerCenter pt-20 mt-30">
              <div className="superRound">
                <span className="superSpan">Loan Offers for You</span>
                <div className="spanBelow"></div>
              </div>

              {credit_model?.credit_limit > 0 && loanType === "P" && (
                <SuperInstant
                  loanDetails={{}}
                  credit={credit_model}
                  amount={credit_model?.credit_limit || "0"}
                  loanType={loanType}
                  statusEmi={emi}
                  loanStatus={loanStatus}
                  topCoverState={true}
                  event={"loan"}
                  documentStatus={basicDetails}
                  loanStatusData={loanStatus}
                />
              )}

              {(credit_model?.credit_limit === undefined ||
                credit_model?.credit_limit <= 0) && (
                <div className="mt-22 pt-20 pb-20 superLoanBox">
                  <span>Hey, You're New to Credit</span>
                </div>
              )}
            </div>
            )}
          </>
        )}
      </div>
      {blocked &&
        loanStatus?.loan_status !== "DISBURSED" &&
        loanStatus?.loan_status !== "PASSED" &&
        loanStatus?.loan_status !== null &&
        loanStatus?.loan_status !== "BALANCE_AMOUNT" && (
          <>
          <div className="lr-margin-bottom">
           {/* <ModalFailed state={true} /> */}
          <LoanRejectZet />
          </div>
          </>
        )}

      <div
        className={
          isLargeScreen ? "outerOtherProductSection mb-30" : "mb-30 plf-20"
        }
      />
      <div className="toolbarRespo" style={{ padding: "5px" }} />

      <ToggleBar cibilFlow={basicDetails?.cibil_flow} />
    </div>
  );
}

export default LoanSuperAppDashboard;
